import { AlgoConfiguration, AlgoData } from "./types";

export const remaining_quantity = (
  traded_quantity: number | undefined,
  configuration: AlgoConfiguration,
  algo_data?: AlgoData | undefined,
  algo_type?: string | undefined
): number | null => {
  let target_quantity = configuration.quantity;

  if (algo_data?.quantity?.kilo_watts !== undefined) {
    target_quantity = algo_data.quantity.kilo_watts / 1000.0;
  }

  if (target_quantity === null) {
    return null;
  }

  // If the terminator has set this, then it means how it wants to trade to reach target position.
  if (
    algo_type == "terminator" &&
    algo_data?.quantity?.kilo_watts !== undefined
  ) {
    return target_quantity; // In this specific scenario this means remaining.
  }

  const remaining = target_quantity - (traded_quantity ?? 0);
  return parseFloat(remaining.toFixed(1));
};

export const focusField = (ref?: React.RefObject<HTMLInputElement | null>) => {
  setTimeout(() => {
    // timeout of 0 might seem wierd but this helps ensuring that the DOM is rendered before selecting the field
    ref?.current?.focus();
    ref?.current?.select();
    // Cleanup to blur when unmounting, to avoid reverting to previous selection
    return () => {
      ref?.current?.blur();
    };
  }, 0);
};
